import React from 'react'

import {
  createStyles,
  Grid,
  Theme,
  WithStyles,
  withStyles,
} from '@material-ui/core'

import {
  RouteComponentProps,
  HashRouter as Router,
  withRouter,
} from 'react-router-dom'

import { AppContext, AppContextProvider } from './contexts/AppContext'

import { GatoHeader, Loading } from '@elgatoylacaja/components'

import {
  GatoLogoProvider,
  LoadingProvider,
  useGatoLogo,
  useLoader,
  useScrollTop,
  useWindowSize,
} from '@elgatoylacaja/hooks'

import SwitchRoutes from './LazySwitchRoutes'

const styles = (theme: Theme) =>
  createStyles({
    app: {
      textAlign: 'center',
      maxWidth: '800px',
      width: '100%',
      margin: '0 auto',
      padding: '0',
      minHeight: '100vh',
    },
    container: {
      padding: 24,
      paddingTop: 0,
      position: 'relative',
      width: '800px',
      '@media only screen and (max-width : 800px)': {
        width: '100%',
      },
      display: 'flex',
      flexDirection: 'column',
    },
    logo: {
      height: 60,
      display: 'block',
      margin: '0px auto',
      paddingTop: '24px',
    },
  })

const Loader = () => {
  const { loading } = useLoader()
  return <Loading fixed loading={loading} />
}

const showGatoLogoUrls = [
  '/terms',
  '/intro',
  '/emocion',
  '/background',
  '/feedback',
  '/thanks',
].flatMap(x => [x, '/demo' + x])

const Container: React.FC<RouteComponentProps &
  WithStyles<typeof styles>> = props => {
  useScrollTop(props.location.pathname)

  const { shouldShowGatoLogo } = useGatoLogo(
    showGatoLogoUrls,
    props.location.pathname
  )

  const { height } = useWindowSize()

  const minHeight = height !== undefined ? `${height}px` : `100vh`

  return (
    <>
      {shouldShowGatoLogo ? <GatoHeader /> : null}
      <Grid
        container
        justify="center"
        style={{
          minHeight: shouldShowGatoLogo
            ? `calc(${minHeight} - 84px)`
            : `calc(${minHeight})`,
        }}
      >
        <Grid item className={props.classes.container}>
          {props.children}
        </Grid>
      </Grid>
    </>
  )
}

const FinalContainer = withRouter(Container)

const Initializer = () => {
  const { dispatch } = React.useContext(AppContext)
  React.useEffect(() => {
    dispatch({
      type: 'INITIALIZE',
    })
  }, [dispatch])
  return <></>
}

const App = ({ classes }: WithStyles<typeof styles>) => {
  return (
    <div className={classes.app}>
      <AppContextProvider>
        <LoadingProvider>
          <GatoLogoProvider>
            <Router hashType="slash">
              <Initializer />
              <Loader />
              <FinalContainer classes={classes}>
                <SwitchRoutes />
              </FinalContainer>
            </Router>
          </GatoLogoProvider>
        </LoadingProvider>
      </AppContextProvider>
    </div>
  )
}

export default withStyles(styles)(App)
